// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PricedOrderListItem_priced-order__3\\+k0m {
  border: 0.1rem solid var(--primary-color);
  border-radius: 0.8rem;
}

.PricedOrderListItem_priced-order__link__dDdid {
  padding: 2rem 5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.PricedOrderListItem_priced-order__link-text__ZvZij {
  color: #000;
  font-size: var(--text-lg);
  font-weight: 500;
}

.PricedOrderListItem_priced-order__link-arrow__i5eQV {
  width: 1rem;
  height: 1rem;
  border: solid #000;
  border-width: 0.2rem 0 0 0.2rem;
  transform: rotate(-45deg);
  padding: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PricedOrders/PricedOrderListItem/PricedOrderListItem.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".priced-order {\n  border: 0.1rem solid var(--primary-color);\n  border-radius: 0.8rem;\n}\n\n.priced-order__link {\n  padding: 2rem 5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.priced-order__link-text {\n  color: #000;\n  font-size: var(--text-lg);\n  font-weight: 500;\n}\n\n.priced-order__link-arrow {\n  width: 1rem;\n  height: 1rem;\n  border: solid #000;\n  border-width: 0.2rem 0 0 0.2rem;\n  transform: rotate(-45deg);\n  padding: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"priced-order": `PricedOrderListItem_priced-order__3+k0m`,
	"priced-order__link": `PricedOrderListItem_priced-order__link__dDdid`,
	"priced-order__link-text": `PricedOrderListItem_priced-order__link-text__ZvZij`,
	"priced-order__link-arrow": `PricedOrderListItem_priced-order__link-arrow__i5eQV`
};
export default ___CSS_LOADER_EXPORT___;
